/* ============================================================
   Major Fade Duo — variant sync between the hero picker (top)
   and the PDP buy block (bottom).

   Switching a size in one selects the matching option in the other.
   Match key = variant id (each block's product's selected/first
   variant); if no id match is found we fall back to POSITION
   (hero pill #n ↔ pdp option #n) — the "1↔2" fallback.

   Hero pills fire their own click → hero JS updates the hero UI.
   PDP options are switched via the <ia-lndg-pdp> element's public
   `select(index)` method (no synthetic click needed). A `syncing`
   guard + the guard-flag on the echoed .click() prevent a loop.
   ============================================================ */
(function () {
  if (window.__iaLndgVariantSync) return;
  window.__iaLndgVariantSync = true;

  function init() {
    var hero = document.querySelector(".ia-lndg-hero");
    var pdp = document.querySelector("ia-lndg-pdp");
    if (!hero || !pdp) return;

    var pills = Array.prototype.slice.call(
      hero.querySelectorAll(".ia-lndg-hero__size")
    );
    var options = Array.prototype.slice.call(
      pdp.querySelectorAll("[data-pdp-option]")
    );
    if (!pills.length || !options.length) return;

    // pdp index -> variant id (read from the inert product-data scripts)
    var pdpVariantByIndex = {};
    pdp.querySelectorAll("[data-pdp-data]").forEach(function (el) {
      try {
        var d = JSON.parse(el.textContent);
        pdpVariantByIndex[Number(el.dataset.pdpData)] = String(d.variantId);
      } catch (e) {}
    });

    var syncing = false;

    function pdpIndexForPill(pill, pillIdx) {
      var vid = pill.getAttribute("data-variant-id");
      if (vid) {
        for (var i in pdpVariantByIndex) {
          if (pdpVariantByIndex[i] === String(vid)) return Number(i);
        }
      }
      return pillIdx < options.length ? pillIdx : -1; // positional fallback
    }

    function pillForPdpIndex(idx) {
      var vid = pdpVariantByIndex[idx];
      if (vid) {
        for (var i = 0; i < pills.length; i++) {
          if (String(pills[i].getAttribute("data-variant-id")) === vid)
            return pills[i];
        }
      }
      return pills[idx] || null; // positional fallback
    }

    // Hero pill clicked → switch the PDP block.
    pills.forEach(function (pill, i) {
      pill.addEventListener("click", function () {
        if (syncing) return;
        var idx = pdpIndexForPill(pill, i);
        if (idx < 0) return;
        syncing = true;
        try {
          // Driven from the top → land on the one-time (no-subscription) option.
          if (typeof pdp.select === "function")
            pdp.select(idx, { forceOneTime: true });
        } catch (e) {}
        syncing = false;
      });
    });

    // PDP option clicked → select the matching hero pill.
    options.forEach(function (opt) {
      opt.addEventListener("click", function () {
        if (syncing) return;
        var pill = pillForPdpIndex(Number(opt.dataset.index));
        if (!pill) return;
        syncing = true;
        try {
          pill.click();
        } catch (e) {}
        syncing = false;
      });
    });
  }

  // Wait for the PDP custom element to be defined so `select` exists.
  function ready() {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined("ia-lndg-pdp").then(init);
    } else {
      init();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }
})();
